import React from 'react';
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { TangModalHeader } from '../components/TangModalHeader';
import { LoginModal, useLoginModalFlow } from '../context/LoginModalFlowContext';
import { IconWarning } from '../assets/IconWarning';
import { getLink } from '../../utils';
import { ImageModalWhiteCellphone } from '../assets/ImageModalWhiteCellphone';

export function PasswordLastChanceModal() {
  const { t } = useTranslation('modais'); 
  
  const modalFlow = useLoginModalFlow();

  function toggleModal() {
    modalFlow.closeModal(LoginModal.PASSWORD_LAST_CHANCE)
  }

  function handleResetPasswordRedirect () {
    window.location.href = getLink('recuperar/senha');
  }
  
  return (
    <SmlsModal
      type="right"
      isOpen={modalFlow.isModalOpen(LoginModal.PASSWORD_LAST_CHANCE)}
      className="tang-modal"
      toggle={toggleModal}
      defaultHeader={false}
    >
      <TangModalHeader showCloseButton onClose={toggleModal} />
      <ModalBody data-testid="modal-body">
        <div className="modal-content">
          <div>
            <div className="modal-icon">
              <ImageModalWhiteCellphone />
            </div>
            <p className="modal-title">{t('acesso_03.title')}</p>
            <p className="modal-subtitle">
              {t('acesso_03.text')}
            </p>
            <div className="warning-box">
              <IconWarning />
              <p>{t('acesso_03.text2')}</p>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <SmlsButton text={t('acesso_03.button_primary')} color="hyperlink" onClick={handleResetPasswordRedirect} />
        <SmlsButton text={t('acesso_03.button_secondary')} onClick={toggleModal} className="button"  />
      </ModalFooter>
    </SmlsModal>
  );
}
